<template lang="pug">
  include ./../../../mixins
  div
    +b.g-row--space_xl-xl.el--m_b_md.--m_b_none-lg
      +b.g-cols--12.--4-mac.--6-sm.g-cell.rel.el--m_h_xs.--m_h_2xs-xl.rel(
        v-for="item in itemsLengts"
      )
        +b.block_content-reviews.--overlay(
          :class="selectedItem == item  ? 'active': ''"
        )
          +b.icon--download.A(v-if="item.link_pdf", :href="item.link_pdf", target="_blank")
          +b.g-row--align_center
            +b.g-cols.g-cell
              +b.img--testimanilas.IMG(:src="item.image")
            +b.g-cols.g-cell.el--m_l_1xs-xl
              +b.el
                +b.P.ds-caption--size_1sm.--size_lg-lg.--c_blue.--w_b {{item.name}}
              +b.el--p_t_1xs
                +b.H3.ds-caption--size_1xs.--size_sm-lg.--c_lgrey.--w_r {{item.position}}
          +b.el--p_t_md-xl.--p_t_sm.over-cards
            +b.P.ds-caption--size_1xs.--size_1md-lg.--c_lgrey.--w_r.--h_xs.--h_lg-xl
              | {{item.description }}
          +b.el--p_t_2xs.--p_t_md-lg
            +b.g-row--justify_between.g-cell
              +b.P.ds-caption--size_xs.--c_lgrey.--w_r.el--p_b_md.--p_b_none-md {{item.date}}
              +b.P.ds-caption--size_1sm.--c_lb.--w_b.--hover_line.g-cols--12.g-cols--narrow-md(
                @click="handleClick(item)"
                :item="item"
                :isSelected="selectedItem"
                v-if="item.lengt > numberLength && selectedItem !== item"
              )
                | {{trans.title_btn_reviews}}
              +b.P.ds-caption--size_1sm.--c_lb.--w_b.--hover_line.g-cols--12.g-cols--narrow-md(
                @click="handleClick(item)"
                v-if="selectedItem == item"
              )
                | {{trans.title_btn_reviews_close}}
</template>
<script>

export default {
  data() {
    return {
      selectedItem: null,
      numberLength: Number,
    }
  },
  props: {
    itemsLengts: [],
  },
  mounted() {
    if (window.innerWidth >= 320) {
      this.numberLength = 400
    }
    if (window.innerWidth >= 1200) {
      this.numberLength = 580
    }
    if (window.innerWidth >= 1508) {
      this.numberLength = 430
    }
  },
  methods: {
    handleClick(item) {
      if (this.selectedItem !== item) {
        this.selectedItem = item
      } else {
        this.selectedItem = ''
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/UiElements/ReadMoreReviews.vue